var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shortcuts-row"},[_c('div',{staticClass:"shortcuts-keys"},[_vm._t("key")],2),_c('div',{staticClass:"shortcuts-description"},[_vm._t("description")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }